import { getAnnouncement } from "@/Services/Announcement";
import { Announcement } from "@/Contracts";
import { Action, Dispatch } from "redux";

export enum AnnouncementActionTypes {
	GET_ANNOUNCEMENT = "GET_ANNOUNCEMENT",
	REGISTER_USER_INTERACTION = "REGISTER_USER_INTERACTION"
}

export interface GetAnnouncementAction
	extends Action<AnnouncementActionTypes.GET_ANNOUNCEMENT> {
	readonly announcement: Announcement | null;
}

export type AnnouncementActions = GetAnnouncementAction;

export const AnnouncementActionCreators = {
	getAnnouncement: () => {
		return async (dispatch: Dispatch): Promise<GetAnnouncementAction> => {
			const announcementResponse = await getAnnouncement();
			const getAnnouncementAction: GetAnnouncementAction = {
				type: AnnouncementActionTypes.GET_ANNOUNCEMENT,
				announcement: announcementResponse ?? null
			};
			return dispatch(getAnnouncementAction);
		};
	}
};

export default AnnouncementActionCreators;
